export class TrackingItemsDto {
  itemId: string;
  itemName: string;
  affiliation?: string;
  coupon?: string;
  discount: number;
  index?: number;
  itemBrand: string;
  itemCategory: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  itemListId?: string;
  itemListName: string;
  itemVariant: string;
  locationId: string;
  promotionId: string;
  promotionName: string;
  price: number;
  quantity: number;
}

export class TrackingDto {
  event: string;
  eventType: string;
  currency: string;
  value: number;
  coupon?: string;
  paymentType?: string;
  transactionId?: string;
  shipping?: number;
  tax?: number;
  items: TrackingItemsDto[];
}

export enum TrackingEvent {
  PAGE_VIEW = 'page_view',

  CLICK = 'click',

  ADD_TO_CART = 'add_to_cart',
  REMOVE_FROM_CART = 'remove_from_cart',
  SELECT_ITEM = 'select_item',
  ADD_PAYMENT_INFO = 'add_payment_info',
  BEGIN_CHECKOUT = 'begin_checkout',
  ADD_SHIPPING_INFO = 'add_shipping_info',
  SELECT_PROMOTION = 'select_promotion',
  VIEW_CART = 'view_cart',
  VIEW_ITEM = 'view_item',
  PURCHASE = 'purchase',
  SEARCH = 'search',

  LOGIN_PROGRESS = "login_progress",

  SIGNUP_PROGRESS = "signup_progress",

  IBCREDIT_GST = 'ibcredit_gst',
  IBCREDIT_EMAIL = 'ibcredit_email',
  IBCREDIT_MOBILE = 'ibcredit_mobile',
  IBCREDIT_LEAD = 'lead_ibcredit',
}

export enum SignUpStep {
  SIGNUP_INITIATED = "signup_initiated",
  SIGNUP_USER_INFO = "signup_user_info",
  SIGNUP_GSTIN_VERIFICATION = "signup_gstin_verify",
  SIGNUP = "signup",
  SIGNUP_FAILED = "signup_failed",
}

export enum LogInStep {
  LOGIN_INITIATED = "login_initiated",
  LOGIN_USERNAME = "login_username",
  LOGIN = "login",
  LOGIN_FAILED = "login_failed",
}